// Four decimals bucket near-identical GPS positions so tiny pans do not miss React Query caches.
const MAP_COORDINATE_PRECISION = 4;

export const ACTIVITY_POCKET_STALE_TIME_MS = 10 * 60 * 1000;

export const activityPocketKeys = {
  all: ['activity-pockets', 'by-location'] as const,
  list: (params: { latitude: number; longitude: number }) =>
    [...activityPocketKeys.all, params] as const,
};

export function roundMapCoordinate(value: number) {
  const scale = 10 ** MAP_COORDINATE_PRECISION;
  return Math.round(value * scale) / scale;
}

export function getActivityPocketsQueryValues(params: { latitude: number; longitude: number }) {
  return {
    latitude: roundMapCoordinate(params.latitude),
    longitude: roundMapCoordinate(params.longitude),
  };
}

export function buildActivityPocketsPath(params: { latitude: number; longitude: number }) {
  const queryValues = getActivityPocketsQueryValues(params);
  const searchParams = new URLSearchParams({
    lat: String(queryValues.latitude),
    lng: String(queryValues.longitude),
  });
  return `/activity-pockets?${searchParams.toString()}`;
}

export function getActivityPocketsQueryOptions<TResponse, TResult>(
  params: { latitude: number; longitude: number },
  request: (path: string) => Promise<TResponse>,
  select: (response: TResponse) => TResult
) {
  const queryValues = getActivityPocketsQueryValues(params);
  return {
    queryKey: activityPocketKeys.list(queryValues),
    staleTime: ACTIVITY_POCKET_STALE_TIME_MS,
    // Use the same rounded values for cache keys and requests so nearby pans truly share results.
    queryFn: async () => select(await request(buildActivityPocketsPath(queryValues))),
  };
}

export function buildNearbyVenuesPath(params: {
  latitude: number;
  longitude: number;
  originLatitude: number;
  originLongitude: number;
  radiusMiles: number;
  category: string;
  limit: number;
}) {
  const searchParams = new URLSearchParams({
    lat: String(roundMapCoordinate(params.latitude)),
    lng: String(roundMapCoordinate(params.longitude)),
    origin_lat: String(roundMapCoordinate(params.originLatitude)),
    origin_lng: String(roundMapCoordinate(params.originLongitude)),
    radius: String(params.radiusMiles),
    limit: String(params.limit),
  });
  if (params.category.trim()) {
    searchParams.set('category', params.category.trim());
  }
  return `/venues/nearby?${searchParams.toString()}`;
}
